<template>
  <el-dialog
    title="创建调拨出库单"
    :visible.sync="visible"
    width="840px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :rules="rules"
      :model="orderInfo">
      <el-form-item label="调拨单号:"> {{ orderInfo.bizOrderCode }} </el-form-item>
      <el-form-item label="发货仓库:"> {{ orderInfo.warehouseNo | warehouseName() }} </el-form-item>
      <el-form-item
        label="物流方式:"
        prop="transType">
        <el-radio-group v-model="orderInfo.transType">
          <el-radio-button :label="1">陆运</el-radio-button>
          <el-radio-button :label="2">空运</el-radio-button>
          <el-radio-button :label="3">自提</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="orderInfo.transType !== 3">
        <el-form-item
          label="快递模板:"
          prop="expressCode">
          <ent-logistics-select
            ref="logistics"
            v-model="orderInfo.expressCode"
            :callback="logisticsSelectCallback"
            :option="{vendorId: userInfo.orgId}" />
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip
              effect="dark"
              content="根据物流模板信息获取">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span>发件人:</span>
          </div>
          {{ orderInfo.senderName }}-{{ orderInfo.senderMobile }}-{{ orderInfo.senderProvince }}{{ orderInfo.senderCity }}{{ orderInfo.senderDistrict }}{{ orderInfo.senderAddress }}
        </el-form-item>
      </template>
      <el-form-item
        label="收件人姓名:"
        prop="receiverName">
        <el-input v-model="orderInfo.receiverName"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人手机:"
        prop="receiverMobile">
        <el-input v-model="orderInfo.receiverMobile"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人电话:"
        prop="receiverTel">
        <el-input v-model="orderInfo.receiverTel"></el-input>
      </el-form-item>
      <el-form-item
        :required="orderInfo.transType !== 3"
        style="margin-bottom:0"
        label="收件省市区:">
        <el-row :gutter="0">
          <el-col :span="7">
            <el-form-item
              label-width="0"
              prop="receiverProvince">
              <el-input v-model="orderInfo.receiverProvince"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverCity">
              <el-input v-model="orderInfo.receiverCity"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverDistrict">
              <el-input v-model="orderInfo.receiverDistrict"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="收件地址:"
        prop="receiverAddress">
        <el-input v-model="orderInfo.receiverAddress"></el-input>
      </el-form-item>
      <el-form-item
        v-if="orderInfo.remark"
        label="备注:"> {{ orderInfo.remark }}</el-form-item>
      <el-form-item
        label="待调拨明细:"
        prop="detailList">
        <el-table
          v-loading="loading"
          max-height="400px"
          :data="orderInfo.detailList"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName"></el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="80"
            prop="skuCode"></el-table-column>
          <el-table-column
            label="调拨数量"
            width="70"
            :resizable="false"
            prop="num">
            <template slot-scope="scope">{{ scope.row.num }} {{ scope.row.measureUnit | measureUnitName() }}</template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            width="100"
            label="出库单">
            <el-table-column
              :resizable="false"
              width="70"
              label="已生成"
              prop="outOrderNum">
              <template slot-scope="scope">{{ scope.row.outOrderNum || 0 }} {{ scope.row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
            <el-table-column
              :resizable="false"
              width="70"
              label="待生成"
              prop="needOut">
              <template slot-scope="scope">{{ scope.row.needOut }} {{ scope.row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="出库数量"
            :resizable="false">
            <template slot-scope="{row,$index}">
              <el-form-item
                style="margin-bottom:0"
                label-width="0"
                :prop="'detailList.' + $index + '.tempnum'">
                <el-input-number
                  v-model="orderInfo.detailList[$index].tempnum"
                  style="width: 100%"
                  :precision="0"
                  :max="row.needOut"
                  :min="0"></el-input-number>
                <!-- <el-popover
                  placement="top"
                  title="库存"
                  trigger="hover">
                  <div style="font-size: 12px;">
                    <div>仓库：{{ row.warehouse.warehouseNo| warehouseName() }}</div>
                    <div>库存：{{ row.warehouse.num }}</div>
                  </div>
                  <el-input-number
                    slot="reference"
                    v-model="orderInfo.detailList[$index].tempnum"
                    style="width: 100%"
                    :precision="0"
                    :max="row.needOut"
                    :min="0"></el-input-number>
                </el-popover> -->
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="addOut">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'
import { mapState } from 'vuex'
// import _ from 'lodash'
export default {
  name: 'AllocateOutModal',
  components: { EntLogisticsSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      allocateOrderId: null,
      orderInfo: {
        bizOrderId: null,
        bizOrderCode: null,
        ownerCode: null,
        outType: 0,
        type: 23,
        warehouseNo: null,
        transType: 1,
        packageNum: 1,
        expressCode: null,
        senderName: '',
        senderProvince: '',
        senderCity: '',
        senderDistrict: '',
        senderAddress: '',
        senderMobile: '',
        receiverName: '',
        receiverMobile: '',
        receiverTel: '',
        receiverProvince: '',
        receiverCity: '',
        receiverDistrict: '',
        receiverAddress: '',
        detailList: []
      },
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      warehouse: state => state.account.warehouse,
      expressList: state => state.account.expressList
    }),
    rules() {
      const { receiverMobile, receiverTel, transType } = this.orderInfo
      return {
        transType: [{ required: true, message: '请选择发货方式', trigger: 'change' }],
        expressCode: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        packageNum: [{ required: true, message: '请输入包裹数量', trigger: 'blur' }],
        receiverName: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
        receiverMobile: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverTel: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverProvince: [{ required: transType !== 3, message: '请输入收件省份', trigger: 'blur' }],
        receiverCity: [{ required: transType !== 3, message: '请输入收件城市', trigger: 'blur' }],
        receiverDistrict: [{ required: transType !== 3, message: '请输入收件区县', trigger: 'blur' }],
        receiverAddress: [{ required: transType !== 3, message: '请输入收件地址', trigger: 'blur' }]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    logisticsSelectCallback(row) {
      this.orderInfo.senderName = row.senderName
      this.orderInfo.senderProvince = row.senderProvinceName
      this.orderInfo.senderCity = row.senderCityName
      this.orderInfo.senderDistrict = row.senderAreaName
      this.orderInfo.senderAddress = row.senderAddress
      this.orderInfo.senderMobile = row.senderPhone
    },
    handleClosed() {},
    addOut() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const detailList = this.orderInfo.detailList.filter(s => s.tempnum > 0)
          if (detailList.length === 0) {
            this.$message.error('出库数量不能为空')
            return
          }
          this.loading = true
          const {
            bizOrderId,
            bizOrderCode,
            warehouseNo,
            ownerCode,
            outType,
            type,
            expressCode,
            packageNum,
            receiverName,
            receiverMobile,
            receiverTel,
            receiverProvince,
            receiverCity,
            receiverDistrict,
            receiverAddress,
            transType
          } = this.orderInfo
          this.$store.dispatch('outstock/outsendadd', {
            payload: {
              bizOrderId,
              bizOrderCode,
              warehouseNo,
              ownerCode,
              outType,
              type, // 'int //单据类型 XSCK(21, "销售出库"), PDCK(22, "盘点出库"), DBCK(23, "调拨出库"), SCCK(24, "调拨出库"), QTCK(99, "其他出库");
              expressCode,
              packageNum,
              receiverName,
              receiverMobile,
              receiverTel,
              receiverProvince,
              receiverCity,
              receiverDistrict,
              receiverAddress,
              transType,
              detailList: detailList.map(s => {
                return {
                  // outOrderId: bizOrderId,
                  bizOrderDetailId: s.id, // 业务单明细id',
                  skuId: s.skuId,
                  num: s.tempnum,
                  stockId: s.warehouse.id// 库存id,仓库库存Id【必须】',
                }
              })
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/allocatedetail', {
        payload: {
          allocateOrderId: this.allocateOrderId
        },
        success: res => {
          this.loading = false
          res.data.data.detailList.forEach(i => {
            i.needOut = i.num - i.outOrderNum
            i.tempnum = i.num - i.outOrderNum
            i.warehouse = { skuId: i.skuId, id: null, num: 0 }
          })
          const data = res.data.data
          const expressCode = !!data.expressCode && !!(+data.expressCode) ? +data.expressCode : null
          const expressInfo = this.expressList.find(i => i.expressId === expressCode) || {}
          this.orderInfo = {
            ...this.orderInfo,
            bizOrderId: data.id,
            bizOrderCode: data.code,
            ownerCode: data.ownerCode,
            outType: 0,
            type: 23,
            warehouseNo: data.sourceWarehouseNo,
            // warehouseName: (this.warehouse.find(i => i.warehouseNo === data.sourceWarehouseNo) || {}).warehouseName,
            transType: data.transType,
            packageNum: 1,
            expressCode: expressCode,
            senderName: expressInfo.senderName,
            senderProvince: expressInfo.senderProvinceName,
            senderCity: expressInfo.senderCityName,
            senderDistrict: expressInfo.senderAreaName,
            senderAddress: expressInfo.senderAddress,
            senderMobile: expressInfo.senderPhone,
            receiverName: data.receiverName,
            receiverMobile: data.receiverMobile,
            receiverTel: data.receiverTel,
            receiverProvince: data.receiverProvince,
            receiverCity: data.receiverCity,
            receiverDistrict: data.receiverDistrict,
            receiverAddress: data.receiverAddress,
            detailList: data.detailList.filter(i => i.needOut > 0)
          }
          // this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    // getstocklist(warehouseNo, skuIdList) {
    //   this.$store.dispatch('outstock/stocklist', {
    //     payload: {
    //       pageNum: 1,
    //       pageSize: 1000,
    //       warehouseNo,
    //       skuIdList
    //     },
    //     success: (res) => {
    //       console.log(res)
    //       const records = res.data.data.records
    //       this.loading = false
    //       const detailList = _.cloneDeep(this.orderInfo.detailList)
    //       detailList.forEach(i => {
    //         const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
    //         i.warehouse = item
    //         i.maxNum = i.needOut > item.num ? item.num : i.needOut
    //         i.tempnum = i.maxNum
    //       })
    //       this.$set(this.orderInfo, 'detailList', detailList)
    //     },
    //     fail: () => {
    //       this.loading = false
    //       const records = []
    //       const detailList = _.cloneDeep(this.orderInfo.detailList)
    //       detailList.forEach(i => {
    //         const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
    //         i.warehouse = item
    //         i.maxNum = i.needOut > item.num ? item.num : i.needOut
    //         i.tempnum = i.maxNum
    //       })
    //       this.$set(this.orderInfo, 'detailList', detailList)
    //     }
    //   })
    // },
    fetch(allocateOrderId) {
      this.allocateOrderId = allocateOrderId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
